import { makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useCommonJobStyles } from ".";
import { get } from "../../utils/jobsAxiosInstance";
import { DetailedJobViewer } from "./Jobs";
import { convertToGoogleJobsJSON } from "../../utils/helper";

const useStyles = makeStyles((theme) => ({
    mainContent: {
        [theme.breakpoints.down("xs")]: {
            margin: '2rem auto 0 auto',
        },
        margin: '5rem auto 0 auto',
    },
}))
const IndexingJobDetailsPage = () => {

    const { jobId } = useParams();
    const commonStyles = useCommonJobStyles();
    const classes = useStyles();
    const [jobDetail, setJobDetail] = useState(null);

    useEffect(() => {
        let script;
        get(`getJob/${jobId}`)
            .then((res) => {
                setJobDetail(res.data.elasticJob);

                script = document.createElement('script');
                script.type = 'application/ld+json';
                script.innerHTML = JSON.stringify(convertToGoogleJobsJSON([res.data.elasticJob]));
                document.head.appendChild(script);
            })
            .catch(() => {
            })

        return () => {
            document.head.removeChild(script);
        };
    }, [jobId])

    return (
        <div className={`${commonStyles.root} ${classes.mainContent}`}>
            <section>
                {jobDetail ? <DetailedJobViewer job={jobDetail} /> : <p>Loading...</p>}
            </section>
        </div>
    )
}

export default IndexingJobDetailsPage;